import { render, staticRenderFns } from "./getLock.vue?vue&type=template&id=1fa37612&scoped=true&"
import script from "./getLock.vue?vue&type=script&lang=js&"
export * from "./getLock.vue?vue&type=script&lang=js&"
import style0 from "./getLock.vue?vue&type=style&index=0&id=1fa37612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa37612",
  null
  
)

export default component.exports